import { SelectToggleButtonStyled, SelectToggleButtonStyledRightIconStyled } from "./styled/SelectToggleButtonStyled";
import { BinIcon } from "../icon/Icon";
import { memo } from "react";

export const SelectToggleButton = memo(({children, isOpen, ...props}) => (
    <SelectToggleButtonStyled className={'select-toggle'} isOpen={isOpen} {...props}>
        {children}
        <SelectToggleButtonStyledRightIconStyled className="right-icon" isOpen={isOpen}>
            <BinIcon name="IcChevronDown"/>
        </SelectToggleButtonStyledRightIconStyled>
    </SelectToggleButtonStyled>
));
